import servicesDataJson from "../../data/performanceMarketingServices.json";

export default function Section3() {
  const servicesData = servicesDataJson;

  return (
    <div className="Section3">
      <div className="section3-container">
        <div className="md:w-[61%] my-[24px] mx-5 md:my-0 md:mx-auto text-center">
          <h2 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] mt-[40px]">
            Our Performance Marketing Services
          </h2>
        </div>

        <div className="flex boxes p-[2%_0%_1%_0%] justify-center mx-auto gap-y-[19px] md:gap-y-[30px] gap-x-[2%] flex-wrap w-[85%] min-[481px]:w-full md:w-[85%]">
          {servicesData.map(({ title, text }, index) => {
            return (
              <div
                key={index + title}
                className={`box-${index + 1} ${
                  (index + 1) % 2 === 0
                    ? "bg-[#f5f5f5] text-[#373737]"
                    : "bg-[#E42E35] text-white"
                }  p-[10%] xs:p-[4%] md:p-[3%] w-full xs:w-[40%] md:w-[30%] min-[1150px]:w-[26%]`}
              >
                <h3 className="md:text-[25px] text-[20px] leading-[24px] capitalize font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                  {title}
                </h3>

                <p className="text-[12px] md:text-[14px] mb-5 font-open">{text}</p>
              </div>
            );
          })}
        </div>

        <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    </div>
  );
}
